import { A } from '@adornis/base/env-info.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

@Entity()
export class LecturerComment extends MongoEntity {
  static override _class = 'LecturerComment';
  static override _collectionName = 'lecturer-comments';

  @Field(type => String, { default: v => v ?? A.getGloballyUniqueID() })
  override _id!: string;

  @Field(type => String)
  text: Maybe<string>;

  @Field(type => Date)
  createdAt: Maybe<Date>;

  @Field(type => String)
  lecturerID: Maybe<string>;

  @Field(type => String)
  createdBy: Maybe<string>;

  @Field(type => String)
  institutionID: Maybe<string>;
}
